module.exports = __webpack_public_path__ + "img/parco_la_serra.be6f4a0b.png";